import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


export const loginThunk = createAsyncThunk(
    "login",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.NEXT_PUBLIC_APP_API_URL}/api/auth/login`, data)
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Registration Fail" }
            )
        }
    }
)

export const verifyOtpThunk = createAsyncThunk(
    "verify-otp",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.NEXT_PUBLIC_APP_API_URL}/api/auth/otp-validate`, data)
            return response?.data
        } catch (error) {
            return rejectWithValue(
               error.response?.data || { message: "Registration Fail" }
            )
        }
    }
)

export const getProfileThunk = createAsyncThunk(
    "admin-profile-get",
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.NEXT_PUBLIC_APP_API_URL}/api/user/details`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch profile" }
            )
        }
    }
)

export const updateProfileThunk = createAsyncThunk(
    "admin-profile-update",
    async ({ token, data }, { rejectWithValue }) => {
        try {
            const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
            const response = await axios.put(
                `${process.env.NEXT_PUBLIC_APP_API_URL}/api/user/update`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        ...(isFormData ? { "Content-Type": "multipart/form-data" } : {})
                    }
                }
            )
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to update profile" }
            )
        }
    }
)

export const removeProfilePictureThunk = createAsyncThunk(
    "admin-profile-remove-picture",
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.delete(
                `${process.env.NEXT_PUBLIC_APP_API_URL}/api/user/remove-profile-picture`,
                { headers: { Authorization: `Bearer ${token}` } }
            )
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to remove profile picture" }
            )
        }
    }
)